import About from './pages/About';
// import Contact from './pages/Contact';
import Home from './pages/Home';
import Navbar from './pages/Navbar';
import Skills from './pages/Skills';
import Works from './pages/Works';

function App() {
  return (
    <div >
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Works />
      {/* <Contact /> */}
    </div>
  );
}

export default App;